// extracted by mini-css-extract-plugin
export default {"grid":"diaper-breakdown__grid___qQCV","gridItem":"diaper-breakdown__gridItem__GCgXP","title":"diaper-breakdown__title__LWAHh","subtitle":"diaper-breakdown__subtitle__FLleR"};